const serviceTypeEndpoints = {
  CREATE_SERVICE_TYPE: 'loopay-service-management/service-types',
  SERVICE_TYPES: 'loopay-service-management/service-types',
} as const;

export default serviceTypeEndpoints;
